import { render, staticRenderFns } from "./MatchesPreferences.vue?vue&type=template&id=5bd3a447"
import script from "./MatchesPreferences.vue?vue&type=script&lang=js"
export * from "./MatchesPreferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports